import AuthSuccess from './AuthSuccess';
export default AuthSuccess;
